import React from "react";
import { packClasses } from "Util";

export default function SecondaryButton({
    label,
    className,
    type,
    children,
    ...remainder
}) {
    return (
        <button
            type={type ? type : "button"}
            className={packClasses(
                "focus:outline-none rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50",
                className ? className : ""
            )}
            {...remainder}
        >
            {children ? children : label}
        </button>
    );
}
